import { inject } from 'inversify'
import { err, ok } from '@xlearn/common'
import { waitToLoad, CancelToken, WaitToLoadError } from '@/app/shared/utils'
import { QuizStoreModule, QuizStoreModuleSymbol, FindQuizError  } from '@/app/quiz'

export type LoadQuizError = WaitToLoadError | FindQuizError

export class LoadQuizJob {

  constructor(
    @inject(QuizStoreModuleSymbol)
    private quizStore: QuizStoreModule) {

  }

  async execute(quizId: string, cancel: CancelToken) {
    const result = await waitToLoad(() => this.quizStore.loadingPhase === 'loaded', cancel)
    if (!result.success) {
      return err(result.error as LoadQuizError)
    }

    const findResult = this.quizStore.findQuiz(quizId)
    if (!findResult.success) {
      return findResult
    }

    const quiz = findResult.value
    return ok(quiz)
  }
}
